import React, {memo} from 'react';
import PropTypes from 'prop-types';
import {Badge} from "reactstrap";
import classNames from "classnames";

const StatusColumn = memo(({product, handleToggle}) => (
  <td className="status" align='center'>
    <Badge color="" className="badge-stroke mx-2">
      <i className={classNames({
        'bg-gray': product.status === 0,
        'bg-success': product.status === 1,
        'bg-red-danger': product.status === 2,
        'bg-warning': product.status === 3,
      })}/>
    </Badge>
  </td>
));

StatusColumn.propTypes = {
  product: PropTypes.object.isRequired,
};

export default StatusColumn;
